import axios from "axios";
import {
  SignUpStatsOverview,
} from "../../models/systemAdmin";
import { responseBody } from "../Requests";

export const SystemAdminStats = {
  getSignupStatsOverview: (params: URLSearchParams) => axios.get<SignUpStatsOverview[]>(`/SystemAdminStats/getSignupStats`, { params }).then(responseBody),
}